export default "__VITE_ASSET__45a2dd17__"